// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { Cart } from "../flow/types";
import { utils } from "../common/utils";

export default function (
    state: Cart = initialState.cart,
    action: any
) {
    switch (action.type) {
        case ActionTypes.ADD_TO_CART + ActionTypes.FULFILLED:
            return addToCart(state, action.payload);
        case ActionTypes.UPDATE_CART + ActionTypes.FULFILLED:
            return updateCart(state, action.payload);
       case ActionTypes.REMOVE_FROM_CART + ActionTypes.FULFILLED: {
            const { stockItemId, isPromo } = action.payload;
            return {...state,
            lines: state.lines.filter(line =>!(line.stockItemId === stockItemId && line.isPromo === isPromo))
            };
        }
        case ActionTypes.EMPTY_CART + ActionTypes.FULFILLED:
        case ActionTypes.LOGOUT + ActionTypes.FULFILLED:
            return {...initialState.cart, userId: state.userId};
        case ActionTypes.SAVE_CART + ActionTypes.FULFILLED:
            state.saveAfterCartMerge = false;
            return state;
        case ActionTypes.GET_CART + ActionTypes.FULFILLED:
            let savedCart = action.payload.data ? action.payload.data : initialState.cart;

            if (savedCart.id === 0) {
                state.userId = savedCart.userId;
                state.saveAfterCartMerge = state.lines && state.lines.length > 0; // save cart if the default have lines
                return state;
            }
            savedCart.lines = savedCart.cartJson ? JSON.parse(savedCart.cartJson) : savedCart.lines;
            
            // merge anonymous cart with user saved cart
            if (utils.isNullOrEmpty(state.userId)) {
                var mergedCartLines = Object.values([...savedCart.lines, ...state.lines].reduce((acc, line) => {
                    acc[line.stockItemId] = { ...line, quantity: (acc[line.stockItemId] ? acc[line.stockItemId].quantity : 0) + line.quantity };
                    return acc;
                }, {}));
                savedCart.lines = mergedCartLines;
                savedCart.saveAfterCartMerge = true;
            }

            return savedCart;
        case ActionTypes.SET_CART + ActionTypes.FULFILLED:
            let toLoadCart = action.payload ? action.payload : initialState.cart;
            return toLoadCart;
        default: 
            return state;
    }
}

function addToCart(state: Cart, payload: any) {
    let exist = false;
    const newCartLines = state.lines.map(line => {
        if (line.stockItemId === payload.stockItemId && line.isPromo === payload.isPromo) {
            exist = true;
            return {
                ...line,
                quantity: line.quantity + payload.quantity,
                isPromo: payload.isPromo ?? line.isPromo
            };
        }
        return line;
    });

    if (!exist)
        newCartLines.push(payload);

    return { ...state, lines: newCartLines };
}

function updateCart(state: Cart, payload: any) {
    const newCartLines = state.lines.map(line => {
        if (line.stockItemId === payload.stockItemId && line.isPromo === payload.isPromo) {
            const updatedLine = {
                ...line,
                quantity: payload.quantity,
                isPromo: payload.isPromo ?? line.isPromo
            };

            if (typeof payload.isLoyaltyPointsUsed === 'boolean') {
                updatedLine.isLoyaltyPointsUsed = payload.isLoyaltyPointsUsed;
            }

            return updatedLine;
        }
        return line;
    });
    return { ...state, lines: newCartLines };
}
